export default __webpack_public_path__ + "static/media/portfolio-white.1d5f2b82.svg";